/*
  マスタデータストア
*/
const getDefaultState = () => {
  return {

    /*************************
     * 汎用区分マスタ
     *************************/
    // プランマスタ情報
    // ex { planCd: "BS02001", displayPlanCd: "BS-02-001", planTyp: "1", name: "役員変更(一億超)", nameDetail1: "役員変更", nameDetail2: "一億超", description: "役員の新規追加、・・", price: "1000", autoAddFlg: "false", imageUrl, "@/assets/img/tie-sm.png", isSelected: "" }
    planMstList: [],
    displayPlanList: [],

    // 消費税率区分情報
    // ex { taxRate: "0.1", taxRateIncluded: "1.1", name: "消費税10%", nameAbbrv: "10%" }
    taxRateKbn:{},
    
    // 進捗区分
    // progressKbnList: [
    //   { cd: "10", name: "申込済", nameAbbrv: "申込", colorName: "red", icon: "mdi-gesture-tap-button" },
    //   { cd: "20", name: "本人確認中", nameAbbrv: "本人確認中", colorName: "red", icon: "mdi-account-search-outline" },
    //   { cd: "30", name: "本人確認済", nameAbbrv: "本人確認済", colorName: "red", icon: "mdi-account-check-outline" },
    //   { cd: "40", name: "処理中", nameAbbrv: "処理", colorName: "lime", icon: "mdi-clipboard-edit-outline"  },
    //   { cd: "80", name: "中止", nameAbbrv: "中止", colorName: "grey", icon: "mdi-close-circle-outline" },
    //   { cd: "90", name: "終了", nameAbbrv: "終了", colorName: "green", icon: "mdi-check-decagram"  },
    // ],
    progressKbnList: [],

    // 確認状態区分
    verifyStatusKbnList: [],

    // 処置結果区分
    dealResultKbnList: [],

    // 役員変更区分
    // ex { cd: "10", name: "就任" },
    changeOfficerKbnList: [],
    changeOfficerKbnAppointList: [],
    changeOfficerKbnResignList: [],
    changeOfficerKbnOthersList: [],

    // 資格区分
    // ex { cd: "10", name: "代表取締役" },
    officerKbnList: [],

    /*************************
     * ウエブコンテンツマスタ
     *************************/
    // 登記変更詳細(基本)情報
    baseChangeDetail: "",
    // 登記変更詳細(役員変更区分毎)情報
    // ex { cd: "10", name: "【1】就任役員の住所：\r\n・・・・・・・" },
    changeOfficerDetailList: [],
  };
};

/**
 * ステート
 */
const state = getDefaultState();

/**
 * ゲッター
 */
const getters = {
  /*
   *  プランマスタ取得
   */
  getPlanMstList(state) {
    return state.planMstList;
  },
  /*
   *  プランマスタ取得
   */
  getDisplayPlanList(state) {
    return state.displayPlanList;
  },
  /*
   *  区分マスタ（消費税率区分）取得
   */
  getTaxRateKbn(state) {
    return state.taxRateKbn;
  },
  /*
   *  区分マスタ（進捗状況区分）取得
   */
  getProgressKbnList(state) {
    return state.progressKbnList;
  },
  /*
   *  区分マスタ（確認状態区分）取得
   */
  getVerifyStatusKbnList(state) {
    return state.verifyStatusKbnList;
  },
  /*
   *  区分マスタ（処置結果区分）取得
   */
  getDealResultKbnList(state) {
    return state.dealResultKbnList;
  },  
  /*
   *  区分マスタ（役員変更）取得
   */
  getChangeOfficerKbnList(state) {
    return state.changeOfficerKbnList;
  },
  /*
   *  区分マスタ（役員変更(就任系)）取得
   */
  getChangeOfficerKbnAppointList(state) {
    return state.changeOfficerKbnAppointList;
  },
  /*
   *  区分マスタ（役員変更(退任系)）取得
   */
  getChangeOfficerKbnResignList(state) {
    return state.changeOfficerKbnResignList;
  },
  /*
   *  区分マスタ（役員変更(その他)）取得
   */
  getChangeOfficerKbnOthersList(state) {
    return state.changeOfficerKbnOthersList;
  },
    /*
   *  区分マスタ（資格）取得
   */
  getOfficerKbnList(state) {
    return state.officerKbnList;
  },
  /*
   *  登記変更詳細(基本)情報取得
   */
  getBaseChangeDetail(state) {
    return state.baseChangeDetail;
  },
  /*
   *  登記変更詳細(役員変更区分毎)情報取得
   */
  getChangeOfficerDetailList(state) {
    return state.changeOfficerDetailList;
  },
};
/**
 * ミューテーション
 */
 const mutations = {
  planMstList(state, status) {
    state.planMstList = status;
  },
  displayPlanList(state, status) {
    state.displayPlanList = status;
  },
  taxRateKbn(state, status) {
    state.taxRateKbn = status;
  },
  progressKbnList(state, status) {
    state.progressKbnList = status;
  },
  verifyStatusKbnList(state, status) {
    state.verifyStatusKbnList = status;
  },
  dealResultKbnList(state, status) {
    state.dealResultKbnList = status;
  },
  changeOfficerKbnList(state, status) {
    state.changeOfficerKbnList = status;
  },
  changeOfficerKbnAppointList(state, status) {
    state.changeOfficerKbnAppointList = status;
  },
  changeOfficerKbnResignList(state, status) {
    state.changeOfficerKbnResignList = status;
  },
  changeOfficerKbnOthersList(state, status) {
    state.changeOfficerKbnOthersList = status;
  },
  officerKbnList(state, status) {
    state.officerKbnList = status;
  },
  baseChangeDetail(state, status) {
    state.baseChangeDetail = status;
  },
  changeOfficerDetailList(state, status) {
    state.changeOfficerDetailList = status;
  },

  /**
   * state初期化
   * @param {ストア}} state 
   */
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

/**
 * アクション
 */
 const actions = {
  setPlanMstList(context, info) {
    context.commit("planMstList", info);
  },
  setDisplayPlanList(context, info) {
    context.commit("displayPlanList", info);
  },
  setTaxRateKbn(context, info) {
    context.commit("taxRateKbn", info);
  },
  setProgressKbnList(context, info) {
    context.commit("progressKbnList", info);
  },
  setVerifyStatusKbnList(context, info) {
    context.commit("verifyStatusKbnList", info);
  },
  setDealResultKbnList(context, info) {
    context.commit("dealResultKbnList", info);
  },
  setChangeOfficerKbnList(context, info) {
    context.commit("changeOfficerKbnList", info);
  },
  setChangeOfficerKbnAppointList(context, info) {
    context.commit("changeOfficerKbnAppointList", info);
  },
  setChangeOfficerKbnResignList(context, info) {
    context.commit("changeOfficerKbnResignList", info);
  },
  setChangeOfficerKbnOthersList(context, info) {
    context.commit("changeOfficerKbnOthersList", info);
  },
  setOfficerKbnList(context, info) {
    context.commit("officerKbnList", info);
  },
  setBaseChangeDetail(context, info) {
    context.commit("baseChangeDetail", info);
  },
  setChangeOfficerDetailList(context, info) {
    context.commit("changeOfficerDetailList", info);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
